import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../../../../../global/default-button/default-button';
import { EventAttributeTypesValues } from '../../../../../../../../../api/attributes.dao';
import { REMOVE_TEXT } from '../../../../../../../../../constants/common-labels.constants';
import { ModuleAttributeVM } from './module-attribute.viewmodel';
import { scrollFollowOnExpand } from '../../../../../../../../../infrastructure/utils/scroll.utils';
import { CheckboxValuePicker } from '../checkbox-value-picker/checkbox-value-picker';
import { SelectValuePicker } from '../select-value-picker/select-value-picker';
import './module-attribute.scss';

type Props = {
    vm: ModuleAttributeVM;
    onRemove: () => void;
};

export const ModuleAttribute: React.FC<Props> = observer(({ vm, onRemove }) => {
    const rowRef = useRef<HTMLDivElement>(null);
    const [expanded, setExpanded] = useState(false);

    const handleToggleExpanded = () => {
        if (!expanded && rowRef.current) scrollFollowOnExpand(rowRef.current);
        setExpanded(e => !e);
    };

    const isCheckbox = vm.getInputType() === EventAttributeTypesValues.CHECKBOX;
    const showError = !vm.valid && vm.isTouched();

    return (
        <div ref={rowRef} className='module-attribute'>
            <div className='module-attribute__header'>
                <span className='module-attribute__name'>{vm.getAttributeName()}</span>
                <DefaultButton
                    modifier='remove'
                    text={<FormattedMessage {...REMOVE_TEXT} />}
                    onClick={onRemove}
                />
            </div>
            <hr className='module-attribute__divider' />
            <div className='module-attribute__values'>
                {isCheckbox
                    ? <CheckboxValuePicker />
                    : <SelectValuePicker
                        values={vm.sortedValues}
                        isSelected={vm.isValueSelected.bind(vm)}
                        onToggle={vm.toggleValue.bind(vm)}
                        expanded={expanded}
                        onToggleExpanded={handleToggleExpanded}
                      />
                }
            </div>
            {showError && (
                <div className='module-attribute__error'>
                    <FormattedMessage
                        id='oe.hubModule.attributeValueRequired'
                        defaultMessage='At least one value is required for each attribute'
                        description='Validation error for missing attribute value'
                    />
                </div>
            )}
        </div>
    );
});
